import { createSelector } from "@reduxjs/toolkit";

import { IUserTravelVisa } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { buildSingleItem } from "shared/utils";
import { dataSelector, buildData } from "../helpers";

export const userTravelVisasSelector = createSelector(
  dataSelector,
  data => buildData(data as any, IDataKeys.userTravelVisa) as IUserTravelVisa[]
);

const dataUserTravelVisasSelector = createSelector(dataSelector, data => data.userTravelVisa);

export const userTravelVisaSelectorCreator = (id: string) =>
  createSelector(dataUserTravelVisasSelector, data => {
    const item = data?.[API_ENDPOINTS.USER_TRAVEL_VISA(id)];
    return item ? (buildSingleItem(item) as IUserTravelVisa) : undefined;
  });
